"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDraggable = _interopRequireWildcard(require("react-draggable"));

var _styles = require("@material-ui/core/styles");

var _getImagePoint = require("./utils/getImagePoint");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import "./ImageAnnotationsMarker.scss"
const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "absolute",
    zIndex: props => {
      return props.zIndex;
    } //        top: props => { return props.top + "%" || "50%"},
    //        left: props => { return props.left + "%" || "50%"},

  },
  draghandle: {
    position: "absolute",
    display: "block",
    width: props => {
      return theme.spacing(props.size);
    },
    height: props => {
      return theme.spacing(props.size);
    },
    transform: "translate(-50%, -50%)",
    borderRadius: "50%",
    "&:hover": {
      cursor: props => {
        return props.cursor || "move";
      }
    }
  },
  marker: {
    width: props => {
      return theme.spacing(props.size);
    },
    height: props => {
      return theme.spacing(props.size);
    },
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    top: "0",
    left: "0",
    position: "absolute",
    display: "block",
    transform: "translate(-50%, -50%)",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none"
  },
  label: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "14px"
  }
}));

const ImageAnnotationsMarker = ({
  index,
  position,
  size = 4,
  onStart,
  onDrag,
  onStop
}) => {
  const _useState = (0, _react.useState)("grab"),
        cursor = _useState[0],
        setCursor = _useState[1];

  const handleStart = (event, data) => {
    setCursor('grabbing');
    onStart && onStart(event, data);
  };

  const handleDrag = (event, data) => {
    onDrag && onDrag(event, data);
  };

  const handleStop = (event, data) => {
    setCursor('grab');
    onStop && onStop(event, data);
  };

  const classes = useStyles({
    size,
    zIndex: index,
    cursor: cursor
  });

  if (!position) {
    return false;
  }

  return _react.default.createElement(_reactDraggable.default, {
    bounds: "parent",
    handle: ".draghandle",
    position: position,
    onStart: handleStart,
    onDrag: handleDrag,
    onStop: handleStop
  }, _react.default.createElement("div", {
    className: classes.root
  }, _react.default.createElement("div", {
    className: classes.draghandle + " draghandle"
  }), _react.default.createElement("div", {
    className: classes.marker
  }, _react.default.createElement("div", {
    className: classes.label
  }, index + 1))));
};

var _default = ImageAnnotationsMarker;
exports.default = _default;
module.exports = exports.default;